import { Warning } from '@mui/icons-material';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import PopoverSecretaria from '../PopoverSecretaria';
import ReactComponent from '../ReactComponent';
import QuorumBusiness from '@/dominio/QuorumBusiness';
import AlertaProcessosSemQuorumMinimo from './AlertaProcessosSemQuorumMinimo';
import AlertaProcessosSemConfirmacaoDeVoto from './AlertaProcessosSemConfirmacaoDeVoto';

class AlertasQuorum extends ReactComponent {
    popoverAberto = false;

    handleClickIcone = () => {
        this.popoverAberto = true;
    };

    handleClosePopover = () => {
        this.popoverAberto = false;
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            popoverAberto: observable,
            handleClickIcone: action,
            handleClosePopover: action,
            existemAlertasQuorum: computed,
            carregandoProcessos: computed
        });
    }

    get processosSemQuorumMinimo() {
        return this.store.processosSessao.filter(
            (registro) =>
                !QuorumBusiness.isObedeceQuorumComposicao(registro, this.sessaoStore.sessaoSelecionada?.quorum)
        );
    }

    get processosSemConfirmacaoDeVoto() {
        return this.store.processosSessao.filter((registro) =>
            QuorumBusiness.existeParticipanteComVotoDiferenteDeConfirmado(registro)
        );
    }

    get existemAlertasQuorum() {
        return this.processosSemQuorumMinimo.length > 0 || this.processosSemConfirmacaoDeVoto.length > 0;
    }

    get carregandoProcessos() {
        return this.sessaoStore.carregandoSessao || this.pautaJulgamentoStore.carregandoPauta;
    }

    render() {
        if (this.carregandoProcessos || !this.existemAlertasQuorum) {
            return null;
        }

        return (
            <>
                <Tooltip
                    title={
                        this.existemAlertasQuorum ? (
                            <Typography>Existem pendências de quórum para esta sessão</Typography>
                        ) : null
                    }
                >
                    <Box id="iconeAlertasQuorum">
                        <IconButton
                            onClick={this.handleClickIcone}
                            sx={{ color: 'darkorange' }}
                            disabled={!this.existemAlertasQuorum}
                        >
                            <Warning />
                        </IconButton>
                    </Box>
                </Tooltip>
                {this.popoverAberto && (
                    <PopoverSecretaria
                        open={this.popoverAberto}
                        onClose={this.handleClosePopover}
                        anchorEl={() => document.getElementById('iconeAlertasQuorum')}
                        placement="bottom"
                    >
                        <Box style={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography
                                variant="h6"
                                color="primary"
                            >
                                Pendências
                            </Typography>
                            <AlertaProcessosSemQuorumMinimo processos={this.processosSemQuorumMinimo} />
                            <AlertaProcessosSemConfirmacaoDeVoto processos={this.processosSemConfirmacaoDeVoto} />
                        </Box>
                    </PopoverSecretaria>
                )}
            </>
        );
    }
}

export default inject('stores')(observer(AlertasQuorum));
